const FAQList = [
  {
    question: "Will I be charged after the 14 day trial?",
    ans: `No, you don't have to enter your credit card details to start your Free trial.
     When you decide to continue using My Hours, enter your payment details and you'll be automatically charged each period (monthly or annually).`,
  },
  {
    question: "Can I switch to a Free account after the Pro Trial ends?",
    ans: `Sure! You'll always have a choice between staying on the Pro version that comes with a subscription or downgrading to a Free account. 
    Just keep in mind that you will lose access to Pro features.`,
  },
  {
    question: "What if we need more than 14 days to test the Pro edition?",
    ans: "Just send us an email to support@myhours.com and we'll provide you with an extension.",
  },
  {
    question: "What's included in the Pro Trial?",
    ans: "Pro Trial comes with every feature that My Hours offers. If you have trouble finding a functionality you need, send us an email.",
  },
  {
    question: "What kind of payment do you accept?",
    ans: `We accept Visa, MasterCard, American Express, Discover, and PayPal. Additional payment options,
     including wire transfer, are available for larger teams with 10+ members and an annual payment.`,
  },
  {
    question: "Do you offer discounts?",
    ans: "We offer discounts to non-profit companies and larger teams.",
  },
  {
    question: "What type of support is included?",
    ans: `
  All My Hours users receive email support, while Pro customers can also engage via live chat.
   Our typical response time is less than 24 hours. Teams with 3+ members can sign up for a free training here.`,
  },
  {
    question: `Can I get a refund?`,
    ans: `We issue a refund when My Hours account with active subscription was not being used for a few months.`,
  },
  {
    question: `Can I deactivate inactive team members?`,
    ans: `You can archive inactive team members while keeping their data for reporting. We do not charge for archived team members.`,
  },
];

export { FAQList };
